/* eslint-disable */

// getConnectionEnrollemntStatus
export const getConnectionEnrollemntStatus = connection_status => {
  const buttonState = {
    show: false, // show/hide
    revoke: true, // false for early termination
  };

  switch (connection_status.toLowerCase()) {
    case 'pending':
    case 'enrolled':
      buttonState.show = true;
      buttonState.revoke = true;
      break;
    case 'revoked':
    case 'complete':
    case 'expired':
      buttonState.show = false;
      break;
    case 'active':
      buttonState.show = true;
      buttonState.revoke = false;
      break;
    default:
      break;
  }
  return buttonState;
}



// WEBPACK FOOTER //
// ./src/views/components/EnrolledPatientResultTable/Util.js